<div id="content" class="witout-subnavbar allcp-form" ng-controller="CustomerFieldController">
	<div ng-include="'modules/company/menus/customer_menu.html'"></div>
	<div class="panel-body">
		<div class="col-md-7">
			<form ng-submit="save()" class="form-horizontal allcp-form">
				<h5>Özel Alan Ekle</h5>
				<hr>
				<div class="form-group row">
					<label class="col-md-3 control-label">
						Alan Adı *
						<a href="#" class="hint--medium hint--top"
						   aria-label="*Form içerisinde alacağınız değerlerin tanımlamalarını belirleyin. Örneğin ‘’Ad Soyad’’ , ‘’Telefon Numarası’’,’’Müşteri Notu’’">
							<i class="fa fa-question-circle"></i> </a>
					</label>
					<div class="col-md-9">
						<label for="name21" class="field prepend-icon">
							<input type="text" ng-model="customerField.name" class="gui-input br-light light" placeholder="Alan Adı" required>
							<label for="name21" class="field-icon">
								<i class="fa fa-list-alt"></i>
							</label>
						</label>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-md-3 control-label">
						Alan Türü *
						<a href="#" class="hint--medium hint--top"
						   aria-label="*İstediğimiz bu değerin türü ne olmalıdır. Örneğin ‘’Telefon Numarası’’ istiyorsak burada ‘’sayı’’ değerini istememiz gerekiyor.">
							<i class="fa fa-question-circle"></i> </a>
					</label>
					<div class="col-md-9">
						<label for="field_type" class="field select">
							<select id="type" name="type" ng-model="customerField.type" required>
								<option value="">Alan Türü Seçiniz</option>
								<option value="text">Yazı</option>
								<option value="number">Numara</option>
								<option value="date">Tarih</option>
								<option value="select">Drop-Down (Seçim)</option>
							</select>
							<i class="arrow"></i>
						</label>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-md-3 control-label">
						Alan Değeri
					</label>
					<div class="col-md-9">
						<label for="name21" class="field prepend-icon">
							<input type="text"
								   ng-model="customerField.value"
								   class="gui-input br-light light"
								   placeholder="Alan Değeri"
								   ng-required="customerField.type == 'select'">
							<label for="name21" class="field-icon">
								<i class="fa fa-list-alt"></i>
							</label>
							<p class="help-block" ng-if="customerField.type == 'select'">
								Drop-Down seçtiğiniz zaman, bu alanı doldurmak zorunludur. Ön tanımlı gelecek seçimleri aralarında virgül bırakarak giriniz.
							</p>
						</label>
					</div>
				</div>

				<div class="form-group row" ng-init="customerField.visible = true">
					<label class="col-md-3 control-label">
						Alan Değeri
					</label>
					<div class="col-md-9">
						<div class="checkbox-custom mt10">
							<input type="checkbox"
								   ng-model="customerField.visible"
								   ng-checked="customerField.visible"
								   id="maps">
							<label for="maps">Mobil uygulamada gösterilsin</label>
						</div>
					</div>
				</div>

				<div class="form-group row">
					<div class="col-md-12">
						<button type="submit" class="btn btn-primary pull-right"><span class="fa fa-save"></span> Kaydet</a>
					</div>
				</div>

			</form>
		</div>
	</div>
</div>
